import { QUERY_KEYS } from "@/libraries/constant";
import type { AuthRegisterCredentialsSchema } from "@/schemas";
import type { AuthRegisterResponse, ResError } from "@/types";
import { useMutation } from "@tanstack/react-query";

function useRegisterMember() {
	return useMutation<
		AuthRegisterResponse,
		ResError,
		AuthRegisterCredentialsSchema & { cf_turnstile_token: string }
	>({
		mutationKey: [QUERY_KEYS.MUTATE_AUTH_REGISTER],
	});
}

export default useRegisterMember;
